import { storeToRefs } from 'pinia';
import { usePublicStore } from '@/dashboard/store/publicStore';
import { useAppStore } from '@/dashboard/store/appStore';
import { isUserInProject } from '@/dashboard/utils/user/isUserInProject';

export async function loadProjectPage(shortLink: string) {
  const publicStore = usePublicStore();
  const appStore = useAppStore();

  const { project, currentProjectUser } = storeToRefs(appStore);

  try {
    publicStore.setPageLoader(true);
    publicStore.resetPage();
    publicStore.setShortLink(shortLink);
    await appStore.loadProjectByShortLink(shortLink);

    if (project.value) {
      publicStore.setProject(project.value);

      if (currentProjectUser.value && isUserInProject(project.value, currentProjectUser.value.id)) {
        publicStore.setShowUploadLimitBanner(project.value.upload_limit);
        await appStore.loadWorkspaceById(project.value.workspace_id);
      }
    } else {
      window.location.replace('/401');
    }
  } finally {
    publicStore.setPageLoader(false);
  }
}
